import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import debug from 'debug';

import DesktopLayout from './DesktopLayout/DesktopLayout';
import MobileLayout from './MobileLayout/MobileLayout';
import * as browserTypes from '../../store/actions/browser.types';

const log = debug('app:layout:');

const Layout = props => {
  log('rendering Layout');
  const { browser, children } = props;
  let layout = null;
  switch (browser.mediaType) {
    // put the most popular case first
    case browserTypes.DESKTOP:
      layout = <DesktopLayout {...props}>{children}</DesktopLayout>;
      break;
    case browserTypes.MOBILE:
      layout = <MobileLayout {...props}>{children}</MobileLayout>;
      break;
    case browserTypes.TABLET:
      layout = <MobileLayout {...props}>{children}</MobileLayout>;
      break;
    default:
      layout = <DesktopLayout {...props}>{children}</DesktopLayout>;
      break;
  }
  return layout;
};

Layout.propTypes = {
  browser: PropTypes.shape(browserTypes.PROP_TYPES).isRequired,
  children: PropTypes.node.isRequired,
};

const mapStateToProps = state => ({
  browser: state.browser,
});

export default connect(mapStateToProps)(Layout);



// WEBPACK FOOTER //
// ./src/app/Layout/Layout.js